import 'custom-event-polyfill';
import 'core-js/features/symbol';
import elementClosest from 'element-closest';
import '@trv-ebus/tds-icons/dist/css/tds-icon-sizes.css';
import '../css/channels.less';
import {
  init,
  clearAllWebChatCookies,
  extendUserData,
  updateUserData,
  updateFormData,
  showChatButton,
} from './channels';
import 'whatwg-fetch';

elementClosest(window);

window._Chat = {
  init,
  clearAllWebChatCookies,
  extendUserData,
  updateUserData,
  updateFormData,
  showChatButton,
};

window.dispatchEvent(new CustomEvent('chat.loaded'));
